import { skipToken, useQuery } from '@tanstack/react-query'

import { HIERARCHY_PERMISSIONS } from '@/lib/permissions'
import { usePermissions } from '@/lib/use-permissions'

import { assetsApi } from '../../api/assets-api'
import type { FormatOption } from './print-settings'
import { assetKeys } from '../../api/query-keys'

const PRINTER_FORMATS_STALE_MS = 5 * 60_000

export function usePrinterFormats(entityId: string | null) {
  const { can } = usePermissions()
  const canRead = can(HIERARCHY_PERMISSIONS.read)
  return useQuery<FormatOption[]>({
    queryKey: assetKeys.printerFormats(entityId ?? ''),
    queryFn: entityId !== null && canRead
      ? () => assetsApi.getPrinterFormats(entityId).then((vocabulary) => vocabulary.items)
      : skipToken,
    staleTime: PRINTER_FORMATS_STALE_MS,
  })
}
